import { gql } from '@apollo/client'
import { BlockFragment } from 'app/features/shared/blocks'
import { BaseArticleBlock } from '../blocks.types'

export const WriteForUsBlockFragment: BlockFragment = {
  name: 'writeForUs',
  fragment: gql`
    fragment writeForUs on WriteForUs {
      id
      blockName
      blockType
      excludedPlatforms {
        ios
        android
        web
      }
    }
  `,
  partialFragment: `
    ...on WriteForUs {
      id
      blockName
      blockType
      excludedPlatforms {
        ios
        android
        web
      }
    }
  `,
}

export const WriteForUsBlockType = 'writeForUs'

export interface WriteForUsBlock extends BaseArticleBlock {
  blockType: typeof WriteForUsBlockType
}
